<template>
	<div
		v-if="isPin"
		class="profile-badge"
		:class="`${
			pin.icon === sponsoredStarIcon ? 'profile-badge__sponsored' : 'profile-badge__pin'
		}
            ${isSquare ? 'profile-badge__square' : ''}
        `"
	>
		<span>
			<Icon class="mr-1" type="star" :size="10" color="#ffffff" />
			{{ pin.text }}
		</span>
	</div>
	<div v-else :style="{ backgroundColor: badge.flag_bg_color }" class="profile-badge">
		<span :style="{ backgroundColor: badge.flag_bg_color, color: badge.flag_txt_color }">
			{{ badge.flag_name }}
			<span :style="{ backgroundColor: badge.flag_bg_color }" />
		</span>
	</div>
</template>
<script>
import sponsoredStarIcon from '@/assets/images/icon-sponsored-star.svg'

export default {
	props: {
		badge: {
			type: Object,
			default: () => ({}),
		},
		pin: {
			type: Object,
			default: () => ({}),
		},
		isPin: {
			type: Boolean,
			default: false,
		},
		isSquare: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			sponsoredStarIcon,
		}
	},
}
</script>
<style lang="scss">
.profile-badge {
	height: 22px;
	text-align: right;
	position: absolute;
	border-radius: 8px;
	top: 0;
	right: 0;

	span {
		height: 30px;
		z-index: 0;
		position: relative;
		background: var(--accent-color);
		display: inline-flex;
		align-items: center;
		padding: 5px 10px 5px 10px;
		border-top-right-radius: 8px;
		color: rgb(255, 255, 255);
		font-size: 12px;
		font-family: Inter, sans-serif;
		font-weight: 700;
		line-height: 100%;
	}

	// Start
	span {
		span {
			z-index: -1;
			content: '';
			position: absolute;
			left: -17%;
			top: -2;
			height: 100%;
			width: 100%;
			-webkit-transform: skewX(20deg);
			-moz-transform: skewX(20deg);
			-ms-transform: skewX(20deg);
			transform: skewX(20deg);
		}
	}

	&__pin,
	&__sponsored {
		span::before {
			z-index: -1;
			content: '';
			position: absolute;
			left: -8%;
			top: 0;
			height: 100%;
			width: 100%;
			-webkit-transform: skewX(20deg);
			-moz-transform: skewX(20deg);
			-ms-transform: skewX(20deg);
			transform: skewX(20deg);
		}
	}

	&__pin {
		span,
		span::before {
			background: var(--badge-pin-background);
		}
	}

	&__sponsored {
		span,
		span::before {
			background: var(--badge-sponsored-background);
		}
	}

	&__square {
		span {
			border-radius: 0 !important;
		}
	}
}
</style>
